import React, { FunctionComponent } from "react";
import PrintOptionAttributeComments from "./PrintOptionAttributeComments";
import PrintOptionFontScale from "./PrintOptionFontScale";
import PrintOptionPageHeader from "./PrintOptionPageHeader";
import PrintOptionPageHeaders from "./PrintOptionPageHeaders";
import PrintOptionPaperSizeAndOrientation from "./PrintOptionPaperSizeAndOrientation";
import PrintOptionRowsPerPage from "./PrintOptionRowsPerPage";

const GalleryPrintOptions: FunctionComponent = function GalleryPrintOptions(props) {
	return (
		<>
			<PrintOptionPaperSizeAndOrientation />
			<PrintOptionPageHeader />
			<PrintOptionAttributeComments />
			<PrintOptionPageHeaders />
			<PrintOptionRowsPerPage />
			<PrintOptionFontScale />
		</>
	);
};

export default GalleryPrintOptions;